import { UIThemes } from '@agilox/ui-common';

export const SpinnerVariantClasses = {
	Inverted: {
		[UIThemes.Secondary]:
			'before:border-secondary-400 before:border-b-white dark:before:border-b-[var(--color-secondary-000)]',
		[UIThemes.Dark]: 'before:border-secondary-200 before:border-b-secondary-800!',
		[UIThemes.Primary]:
			'before:border-white dark:before:border-secondary-900 before:border-b-primary-500!',
		[UIThemes.Blue]:
			'before:border-white dark:before:border-secondary-900 before:border-b-[var(--color-plan-primary-500)]!',
		[UIThemes.Red]: 'before:border-white dark:before:border-secondary-900 before:border-b-red-500!',
	},
	Default: {
		[UIThemes.Secondary]: 'before:border-secondary-900 before:border-b-secondary-200',
		[UIThemes.Dark]:
			'before:border-secondary-400 before:border-b-white dark:before:border-b-secondary-900!',
		[UIThemes.Primary]:
			'before:border-primary-900 dark:before:border-primary-900 before:border-b-primary-200!',
		[UIThemes.Blue]:
			'before:border-[var(--color-plan-primary-700)] before:border-b-[var(--color-plan-primary-200)]!',
		[UIThemes.Red]: 'before:border-red-900 before:border-b-red-200!',
	},
} as const;
